import Model from "../Model";

export default class Place extends Model {
    get url() {
        return '/api/places';
    }
}